export default {
  path: 'trade',
  name: 'trade',
  component: () => import('@/views/order/index.vue'),
  meta: {
    locale: '订单与交易',
    requiresAuth: true,
    icon: 'icon-history',
  },
  children: [
    {
      path: 'order-list',
      name: 'orderList',
      component: () => import('@/views/order/list/index.vue'),
      meta: {
        locale: '订单列表',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'special_service', 'treasurer'],
      },
    },
    {
      path: 'reward-list',
      name: 'reward-list',
      component: () => import('@/views/reward/list/index.vue'),
      meta: {
        locale: '打赏列表',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'special_service', 'treasurer'],
      },
    },
    {
      path: 'naming-list',
      name: 'naming-list',
      component: () => import('@/views/reward/naming-list/index.vue'),
      meta: {
        locale: '冠名列表',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'special_service', 'treasurer'],
      },
    },
    {
      path: 'cdkey-order-list',
      name: 'cdkeyOrderList',
      component: () => import('@/views/cdkey/order-list/index.vue'),
      meta: {
        locale: '序列号订单',
        requiresAuth: true,
        roles: ['super', 'admin'],
      },
    },
  ],
};
